// Import Firebase modules
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD07cf8mz6zi4T2BfFI4kgehanMzgqyJJc",
  authDomain: "workforce-7d6e9.firebaseapp.com",
  databaseURL: "https://workforce-7d6e9-default-rtdb.firebaseio.com",
  projectId: "workforce-7d6e9",
  storageBucket: "workforce-7d6e9.appspot.com",
  messagingSenderId: "979299575416",
  appId: "1:979299575416:web:70b92e5fd44ef4698c2f8d",
  measurementId: "G-C551WSFW86",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Storage, and Auth
const firestore = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// ✅ Set session persistence for authentication
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("🔥 Firebase Auth Persistence Enabled!");
  })
  .catch((error) => {
    console.error("⚠️ Error setting auth persistence: ", error);
  });

// Export Firebase instances
export { firestore, storage, auth };
 